import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    allFailed: (batchType: string) => string;
    failed: (batchType: string) => string;
    itemsCount: (count: number) => string;
    foldersCount: (count: number) => string;
    failedTooltip: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Error message when all items in a batch transfer failed */
            allFailed: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (batchType: string): string => __intl__.intl().formatMessage({ id: "UploaderSheetListItemContent.allFailed?c=16y62ezjgwl47", defaultMessage: "{batchType, select, DOWNLOAD {All downloads failed} RENDER {All exports failed} other {All uploads failed}}" }, { batchType: batchType }));
                },
                enumerable: true,
                configurable: true
            },
            /** Error message when a single item transfer failed */
            failed: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (batchType: string): string => __intl__.intl().formatMessage({ id: "UploaderSheetListItemContent.failed?c=1qo17k226nzjx", defaultMessage: "{batchType, select, DOWNLOAD {Download failed} RENDER {Export failed} other {Upload failed}}" }, { batchType: batchType }));
                },
                enumerable: true,
                configurable: true
            },
            /** Title showing count of items being transferred */
            itemsCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "UploaderSheetListItemContent.itemsCount?c=12g8j6dzte074", defaultMessage: "{count, plural, one {1 Item} other {{count} Items}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Title showing count of folders being transferred */
            foldersCount: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number): string => __intl__.intl().formatMessage({ id: "UploaderSheetListItemContent.foldersCount?c=28otpx0dyz5di", defaultMessage: "{count, plural, one {1 Folder} other {{count} Folders}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip text for showing failed items */
            failedTooltip: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploaderSheetListItemContent.failedTooltip?c=km9o48k8vzh9", defaultMessage: "Show failed items" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
